export default "__VITE_ASSET__DnWt0fLI__"